import React from 'react';
import { ConfigProvider } from 'antd';
import PPAOnboardingHeader from 'components/PPAOnboardingHeader';
import AIChat from 'components/AIChat';
import { EAIChatPageId } from 'types/ai';
import { isMobile } from 'utils/common';
import leadFormStyles from 'pages/PPALeadFormPage/s.module.less';
import ProcessBar from '../ProcessBar';
import PrefillNotice from '../PrefillNotice';
import { EInvitedOnboardingStep } from '../../types';
import s from './s.module.less';

interface LayoutProps {
    step: EInvitedOnboardingStep;
    showProcessBar?: boolean;
    showPrefillNotice?: boolean;
    naturalScroll?: boolean;
    aiChatPageId?: EAIChatPageId;
    footer?: React.ReactNode;
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
    step,
    showProcessBar = true,
    showPrefillNotice = true,
    naturalScroll = false,
    aiChatPageId = EAIChatPageId.PROVIDER_ONBOARDING_PROFILE_INTRO,
    footer,
    children,
}) => {
    return (
        <div className={`${leadFormStyles.wrap} ${s.invitedWrap} ${naturalScroll ? s.invitedWrapNatural : ''}`}>
            <PPAOnboardingHeader showLogout />
            <div className={`${leadFormStyles.content} ${s.content} ${naturalScroll ? s.contentNatural : ''}`}>
                <div className={`${leadFormStyles.contentWrap} ${s.contentWrap}`}>
                    <div className={s.contentIn}>
                        <ConfigProvider theme={{ token: { colorPrimary: '#0E62F4' } }}>
                            {showPrefillNotice && <PrefillNotice />}
                            {showProcessBar && <ProcessBar currentStep={step} />}
                            <div className={s.body}>{children}</div>
                            {footer && <div className={s.footerWrap}>{footer}</div>}
                        </ConfigProvider>
                    </div>
                    <div className={leadFormStyles.chatWrap}>
                        <AIChat pageId={aiChatPageId} defaultShow={!isMobile()} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
